import { Reducer } from '@reduxjs/toolkit';
import { StoreInner } from '@types';
import { user } from './user';

type ReducerWrap = {
	[K in keyof StoreInner]: Reducer<StoreInner[K]>;
};

export const reducer: ReducerWrap = { user };
